import { createFileRoute } from '@tanstack/react-router';

import TagForm from './-components/TagForm';

export const Route = createFileRoute('/_authenticated/tags/new')({
    component: TagForm,
});
